import React from "react";
import { Link } from "@mui/material";

interface CommonResendOtpStatusProps {
  otpErrorMessage?: string;
  timer: number;
  isResendDisabled: boolean;
  handleResendOTP: () => void;
}

const CommonResendOtpStatus: React.FC<CommonResendOtpStatusProps> = ({
  otpErrorMessage = "",
  timer,
  isResendDisabled,
  handleResendOTP,
}) => {
  return (
    <div className="div-align">
      {otpErrorMessage && <p className="required-msg">{otpErrorMessage}</p>}
      {timer > 0 && (
        <p>
          Resend OTP in <strong>{timer}</strong> seconds
        </p>
      )}
      <p>
        <Link
          component="button"
          type="button"
          onClick={handleResendOTP}
          variant="body2"
          sx={{ alignSelf: "center", fontWeight: isResendDisabled ? "normal" : "bold" }}
          disabled={isResendDisabled}
          className={`resend-link ${isResendDisabled ? "disabled" : ""}`}
        >
          Resend OTP
        </Link>
      </p>
    </div>
  );
};

export default CommonResendOtpStatus;
